import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const resourceCardsInit = () => {
  const modules = document.querySelectorAll('.gravity-block-dynamic-boxes__box');

  modules.forEach((module) => {
		if(module.closest('.gg-resource-cards') !== null) {
      module.classList.add('gg-resource-cards_box-card');
    }
  });

  const items = document.querySelectorAll('.gg-resource-cards_box-card');
  items.forEach((item, index) => {
    item.classList.add('fade-in-up', `delay-${index}`);
  })
};

Gravity.ready(resourceCardsInit);
